import { render, staticRenderFns } from "./domandaModal.vue?vue&type=template&id=efa50f42&scoped=true&"
import script from "./domandaModal.vue?vue&type=script&lang=ts&"
export * from "./domandaModal.vue?vue&type=script&lang=ts&"
import style0 from "./domandaModal.vue?vue&type=style&index=0&id=efa50f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa50f42",
  null
  
)

export default component.exports